import Vue from 'vue'
import Vuex from 'vuex'


import {getUserStore} from '@milkboxltd/common-components-frontend'
import affiliates from './affiliates'
import managers from './managers'
// todo offers to one store
import offers from './offers/offers'
import advertisers from './offers/advertisers'
import countries from './offers/countries'
import lpOffers from './offers/lpOffers'
import offer from './offers/offer'
import offerHistory from './offers/offerHistory'
import massCampaignsCreation from './offers/massCampaignsCreation'
import verticals from './offers/verticals'
import campaigns from './campaigns'
import reports from './reports'
import pixelLog from './pixelLog'
import alert from './alert'
import cards from './cards'
import domains from './domains'
import invoices from './invoices'
import currencies from './offers/currencies'
import programs from './programs'
import applications from './applications'
import messages from './messages'
import paymentTerms from './paymentTerms'
import customAssets from './customAssets'
import affiliateAlerts from './affiliateAlerts'
import affiliateNews from './affiliateNews'
// todo change this to advertisers once ./offers/advertisers will be refactored
import advertiser from './advertisers'
import blocking from './blocking'
import notifications from './notifications'
import settings from './settings';

Vue.use(Vuex)

// eslint-disable-next-line no-undef
const projectName = process.env.VUE_APP_PROJECT_NAME || 'backoffice'
const user = getUserStore(process.env.VUE_APP_API_URL, projectName)

export default new Vuex.Store({
  state: {
    firstName: '',
    lastName: '',
  },
  modules: {
    affiliates,
    managers,
    offers,
    offer,
    massCampaignsCreation,
    offerHistory,
    verticals,
    advertisers,
    countries,
    lpOffers,
    campaigns,
    user,
    reports,
    alert,
    advertiser,
    pixelLog,
    cards,
    domains,
    invoices,
    currencies,
    programs,
    blocking,
    notifications,
    applications,
    messages,
    paymentTerms,
    customAssets,
    affiliateAlerts,
    affiliateNews,
    settings
  }
})
